import { useMemo } from "react";
import { useCategoriesTree } from "../../../hooks/useCategoriesTree";
import { FiltersTypes } from "../../../common/types/filters/general";
import { buildFlattenedItems } from "./utils";

export function useCustomCategoryFlattenedItems(
    search: string,
    filters: Pick<FiltersTypes, "category">,
) {
    const categories = useCategoriesTree();

    const { items } = useMemo(
        () => buildFlattenedItems(categories, search, filters),
        [categories, search, filters],
    );

    return items;
}
